export const financialAdvisorAI = 'cxp-financial-advisor-ai-web'
export const customerAccountClosureEndpoint =
  'cxp-customer-account-closure-endpoint-web'
export const mocSignup = 'banking-moc-signup-web'
export const mocDDWaiver = 'banking-moc-direct-deposit-waiver-web'
export const mocApy = 'banking-moc-apy-web'
export const apyOnOak = 'banking-apy-on-oak-web'
export const referralsCampaign = 'referrals-campaign-tracker-web'
export const redirectToRegForAllIncompletes =
  'growth-redirect-all-non-reg-complete-to-reg-web'
export const removeEmailMfaExistingUsers =
  'cxp-remove-email-mfa-existing-users-web'
export const kycInReopen = 'funnel-kyc-in-reopen-web'
export const ssnCollisionKyc = 'funnel-ssn-collision-kyc-web'
export const sduiNonRegTierScreen = 'core-sdui-non-reg-tier-screen-web'
export const dynamicRegistration = 'growth-dynamic-registration-web'
export const onboardingEarlyInvestA4Web = 'onboarding-early-invest-a4-web'
export const subscriptionsMfe = 'afw-migrate-subscriptions-mfe-web'
